customElements.get("product-zoom-modal") || customElements.define("product-zoom-modal", class extends HTMLElement {
  connectedCallback() {
    const e = this.querySelector('input[type="checkbox"][data-locker]'), t = this.querySelector("[data-controls]");
    if (!e || !t) return;
    const n = () => {
      return n = e.checked, void requestAnimationFrame(() => {
        let e = "";
        if (n) {
          const n = t.getBoundingClientRect(), o = Math.ceil(window.innerHeight - n.top - 20 + 20);
          o > 0 && (e = `translateY(-${o}px)`);
        }
        document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
          detail: {
            source: "product-zoom-modal",
            transform: e
          }
        }));
      });
      var n;
    };
    e.addEventListener("change", n), n(), this._cleanup = () => e.removeEventListener("change", n);
  }
  disconnectedCallback() {
    this._cleanup?.();
  }
});